export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Harbor Agent</h3>
            <p className="text-sm text-gray-400">
              AI-Native Engineering Tools by Gently Ventures
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Harbor Agent Packs</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/packs/genesis-mission" className="hover:text-white transition-colors">
                  Genesis Mission Pack
                </a>
              </li>
              <li>
                <a href="/packs/tax-assist" className="hover:text-white transition-colors">
                  Tax Assist Pack
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/gentlyventures/harboragent"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  GitHub Repository
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://gentlyventures.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Gently Ventures
                </a>
              </li>
              <li>
                <a
                  href="mailto:support@gentlyventures.com"
                  className="hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">
                Not legal advice
              </li>
              <li className="text-gray-400">
                Not regulatory guidance
              </li>
              <li className="text-gray-400">
                Engineering resource only
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>
            © {new Date().getFullYear()} Gently Ventures. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

